// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"efb66b8c","900":"d247b1ee"}[chunkId] + ".chunk.js";
};